export enum TextTemplateType {
  Default="Default",
  Site="Site",
  Account="Account",
  Edited="Edited"
}
